import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Link } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import PrimaryButton from "@components/buttons/PrimaryButton";
import SecondaryButton from "@components/buttons/SecondaryButton";
import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { PAGE_PATHS } from '../../../constants';

export const PendingDisplay = () => {
  const theme = useTheme();
  return (
    <Grid
      container
      sx={{
        gap: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }}>Pending <KeyboardArrowDownIcon sx={{ fontSize: '18pt', color: theme.palette.grey[600] }} />
    </Grid>
  );
};

export const VerifiedButton = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 150 }}>
      <PrimaryButton disabled={false} loading={false} minWidth="100%">
        <Grid
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center'
          }}>
          <CheckIcon sx={{ fontSize: '14pt' }} /> Verified
        </Grid>
      </PrimaryButton>
    </Box>
  );
};

export const DenyButton = () => {
  const theme = useTheme();
  return (
    <Box sx={{ width: '100%', maxWidth: 150 }}>
      <SecondaryButton border={theme.palette.info.light} minWidth="100%">
        <Grid
          sx={{
            width: '80%',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center'
          }}>
          <CloseIcon sx={{ fontSize: '14pt' }} /> Deny
        </Grid>
      </SecondaryButton>
    </Box>
  );
};

export const UserInfoButton = ({ officialId }: { officialId: number }) => {
  return (
    <Link
      to={`${PAGE_PATHS.users}/${officialId}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        textDecoration: 'none',
        width: '100%',
        height: '100%'
      }}>
      <AccountBoxIcon sx={{ fontSize: '16pt', color: (theme) => theme.palette.grey[600] }} />
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          textDecoration: 'underline',
          color: (theme) => theme.palette.grey[600],

          '&:hover': {
            textDecoration: 'underline'
          }
        }}>
        View Details
      </Typography>
    </Link>
  );
};

export const VerifiedIcon = () => {
  const theme = useTheme();
  return (
    <Grid
      container
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}>
      <CheckCircleOutlineIcon sx={{ color: theme.palette.success.main}} />
    </Grid>
  );
}

export const UnVerifiedIcon = () => {
  return (
    <Grid
      container
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}>
      <CancelIcon color='error'/>
    </Grid>
  );
}
